export default function OddsPill({ label, odds = "1.91" }) {
  return (
    <div className="flex rounded-full overflow-hidden border border-[var(--theme-border)] h-7 w-[90px] bg-[var(--theme-foreground)]">
      <span className="px-1.5 py-0.5 text-[10px] text-gray-500 whitespace-nowrap flex items-center w-[35px] shrink-0">
        {label}
      </span>
      <span className="px-1 py-0.5 text-xs font-medium flex-1 text-center flex items-center justify-center min-w-[50px]">
        {odds}
      </span>
    </div>
  );
}